export default "<b class=\"text-center text-danger\">Zignsec Id verification is failed!</b>\n";